// client/src/components/OnboardingWizard.jsx
import React, { useState } from "react";

export default function OnboardingWizard({ initial = {}, onClose, onFinish }) {
  const [form, setForm] = useState({
    fullName: initial.fullName || "",
    familySize: initial.familySize || "",
    accommodation: initial.accommodation || "",
    city: initial.city || "",
    budget: initial.budget || "",
    vibe: initial.vibe || "",
  });

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,.35)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
    >
      <div
        style={{
          width: 520,
          maxWidth: "90vw",
          background: "#fff",
          borderRadius: 16,
          padding: 20,
          boxShadow: "0 12px 36px rgba(0,0,0,.15)",
        }}
      >
        <h2 style={{ marginTop: 0, marginBottom: 8 }}>Quick setup</h2>
        <p style={{ marginTop: 0, color: "#555" }}>
          A few details so I can tailor suggestions.
        </p>

        {[
          ["Full name", "fullName", "text", "Jane Doe"],
          ["Family size", "familySize", "number", "2"],
          ["Accommodation", "accommodation", "text", "Apartment / House"],
          ["Destination city", "city", "text", "Chicago, IL"],
          ["Monthly budget (USD)", "budget", "number", "2500"],
          ["Vibe", "vibe", "text", "Urban / Suburban / Quiet"],
        ].map(([label, key, type, ph]) => (
          <label key={key} style={{ display: "block", margin: "10px 0" }}>
            <div style={{ fontSize: 12, color: "#666", marginBottom: 6 }}>{label}</div>
            <input
              type={type}
              value={form[key]}
              onChange={set(key)}
              placeholder={ph}
              style={{
                width: "100%",
                padding: "10px 12px",
                borderRadius: 10,
                border: "1px solid #e5e7eb",
                outline: "none",
              }}
            />
          </label>
        ))}

        <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 12 }}>
          <button
            onClick={onClose}
            style={{
              background: "#f3f4f6",
              border: "1px solid #e5e7eb",
              borderRadius: 10,
              padding: "10px 14px",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>
          <button
            onClick={() => onFinish?.(form)}
            style={{
              background: "#1559EA",
              color: "#fff",
              border: "none",
              borderRadius: 10,
              padding: "10px 14px",
              cursor: "pointer",
              fontWeight: 600,
            }}
          >
            Save & continue
          </button>
        </div>
      </div>
    </div>
  );
}
